export default __webpack_public_path__ + "static/media/block_video.a22ac3a4.svg";